import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Provider } from './store';
import { Container } from './Container';
import { Block } from './Block';
import { Textarea } from './Textarea';
import { Select } from './Select';
import { Input } from './Input';
import { Button } from './Button';
import { jsx as _jsx } from "react/jsx-runtime";
export * from './Input';
export * from './Textarea';
export * from './Select';
export * from './Block';
export * from './Button';
export * from './Container';
export * from './Render';
export * from './store';
var InternalLogin = (props, ref) => {
  return /*#__PURE__*/_jsx(Provider, {
    children: /*#__PURE__*/_jsx(Container, _extends({}, props, {
      ref: ref
    }))
  });
};
var Login = /*#__PURE__*/React.forwardRef(InternalLogin);
Login.Block = Block;
Login.Button = Button;
Login.Input = Input;
Login.Textarea = Textarea;
Login.Select = Select;
Login.displayName = 'Login';
export default Login;